
import makerjs from "makerjs";
function B06(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = 0, x2 =b , y0 = 0, y1 = l, y2 =0,glassH = l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
  var TxtL = "L="+L;
}



   var drawAbnormalShapeB06 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "BottomLine": new makerjs.paths.Line([x2,y2], [x0, y0]),
       }
   };
   var drawAbnormalShapeB06MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
       }
   };
   var drawAbnormalShapeB06MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x2, y2- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 - 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB06MarkB, TxtB, [x0, y0 - 2 * markShift], [x2, y2 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB06MarkL, TxtL, [x0-2*markShift, y0], [x1-2*markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB06: drawAbnormalShapeB06,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB06: drawAbnormalShapeB06,
        drawAbnormalShapeB06MarkL: drawAbnormalShapeB06MarkL,
        drawAbnormalShapeB06MarkB:drawAbnormalShapeB06MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B06;